import { ILLGenericKeys} from './index';


export class ILLActiveIngridient {
    activeIngredientName: ILLGenericKeys;
    basisStrength: ILLGenericKeys;
    refCode: ILLGenericKeys;
    numValue: string;
    numValueUnit: ILLGenericKeys;
    denomValue: string;
    denomValueUnit: ILLGenericKeys;
    moiety: ILLGenericKeys[];
    substanceType: string;
}
